import { render, staticRenderFns } from "./surveillance-form.vue?vue&type=template&id=1e7b8076&"
import script from "./surveillance-form.vue?vue&type=script&lang=js&"
export * from "./surveillance-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports